import { BreadcrumbProps } from '../../types';
import { getCategoriesIds } from '../../helpers';

const useFilterBook = ({ breadcrumb }: BreadcrumbProps) => {
  const categoriesIds = getCategoriesIds({ breadcrumb });
  const categoriesBook = ['228310', '309573', '339770'];
  let isBook = false;

  if (categoriesIds.length) {
    const mathCategory = categoriesBook?.find(str => categoriesIds?.some((id: string) => str === id));
    isBook = mathCategory ? true : false;
  }

  return { isBook };
};

export default useFilterBook;
export { useFilterBook };
